import React, { useEffect, useState } from 'react';
import { Card, Col, /*Form,*/ Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  emptyAllRealEstateData,
  getRealEstateByUserId,
  getRealEstateData,
  getRealEstateList
} from 'redux/realEstateSlice';
import { getBranchOfficesByUserId } from 'redux/branchOfficeSlice';
import {
  getPrevStatsProjects,
  getPrevStatsProps,
  getProjectsByMonth,
  getPropsByMonth,
  getStatsProjects,
  getStatsProps
} from 'redux/infoSlice';
import PageHeader from 'components/common/PageHeader';
import CustomMessage from 'components/common/CustomMessage';
import { FaChartPie } from 'react-icons/fa';
// import { monthsArray } from '../filterHelpers';
// import MonthlyChart from './MonthlyChart';
// import AnualChart from './AnualChart';
// import { BranchOfficeFilter } from '../../gestionarPropiedades/tables/propertiesTable/components/filters/BranchOfficeFilter';
// import { SingleREFilter } from './SingleREFilter';
// import FalconCardHeader from 'components/common/FalconCardHeader';

const MisEstadisticas = () => {
  // * States
  const dispatch = useDispatch();
  const { currentUser: userLogged } = useSelector(state => state.login);
  const { realEstateList, realEstate, branchOfficesArray } = useSelector(
    state => state.realEstate
  );
  const { branchOffices } = useSelector(state => state.branchOffice);
  // const {
  //   statsProps,
  //   prevStatsProps,
  //   statsProjects,
  //   prevStatsProjects,
  //   propsByMonth,
  //   projectsByMonth
  // } = useSelector(state => state.info);

  const [mainFilters, setMainFilters] = useState();
  const [anualFilters, setAnualFilters] = useState();
  const [monthFilters, setMonthFilters] = useState();
  const [projAnualFilters, setProjAnualFilters] = useState();
  const [projMonthFilters, setProjMonthFilters] = useState();

  const currentYear = new Date().getFullYear();
  const initialAnual = {
    year: currentYear,
    filterType: 0
  };
  const initialMonth = {
    propertyTypes: [],
    date: `${currentYear}-01-01T07:00:00.002Z`,
    prevDate: `${currentYear - 1}-12-01T07:00:00.002Z`
  };

  // * Methods
  // const GenerateTitle = (title, month) => {
  //   if (mainFilters?.branchOffices?.length) {
  //     const date = new Date(month.date);
  //     const prevDate = new Date(month.prevDate);

  //     return `${title} - ${
  //       monthsArray[date.getMonth()].label
  //     } ${date.getFullYear()} vs. ${
  //       monthsArray[prevDate.getMonth()].label
  //     } ${prevDate.getFullYear()}`;
  //   }

  //   return title;
  // };

  const GetAnual = () =>
    dispatch(getPropsByMonth(mainFilters.branchOffices, anualFilters.year));

  const GetProjAnual = () =>
    dispatch(
      getProjectsByMonth(mainFilters.branchOffices, projAnualFilters.year)
    );

  const GetMonth = () => {
    dispatch(
      getStatsProps(
        mainFilters.branchOffices,
        monthFilters.propertyTypes,
        monthFilters.date
      )
    );
    dispatch(
      getPrevStatsProps(
        mainFilters.branchOffices,
        monthFilters.propertyTypes,
        monthFilters.prevDate
      )
    );
  };

  const GetProjMonth = () => {
    dispatch(
      getStatsProjects(
        mainFilters.branchOffices,
        projMonthFilters.propertyTypes,
        projMonthFilters.date
      )
    );
    dispatch(
      getPrevStatsProjects(
        mainFilters.branchOffices,
        projMonthFilters.propertyTypes,
        projMonthFilters.prevDate
      )
    );
  };

  // * Life Cycle
  useEffect(() => {
    if (userLogged) {
      if (userLogged.typeOfUser === 'cucicba') dispatch(getRealEstateList());
      else {
        dispatch(getRealEstateByUserId(userLogged.id));
        dispatch(getBranchOfficesByUserId(userLogged.id));
      }

      // Seteo valores iniciales para los filtros de mes y año
      setAnualFilters(initialAnual);
      setMonthFilters(initialMonth);
      setProjAnualFilters(initialAnual);
      setProjMonthFilters(initialMonth);
    }
  }, [userLogged]);

  // Seteo filtros iniciales
  useEffect(() => {
    if (realEstateList) {
      setMainFilters({
        realEstateId: mainFilters?.realEstateId || 0,
        branchOffices: []
      });
    } else {
      if (branchOffices?.length) {
        setMainFilters({
          realEstateId: realEstate.id,
          branchOffices: [branchOffices[0]?.id]
        });
      }
    }
  }, [branchOffices, realEstateList, branchOfficesArray]);

  // Actualiza las estadisticas del chart vs mensual de props
  useEffect(() => {
    mainFilters?.branchOffices?.length &&
      mainFilters.realEstateId &&
      GetMonth();
  }, [monthFilters]);

  // Actualiza las estadisticas del chart anual de props
  useEffect(() => {
    mainFilters?.branchOffices?.length &&
      mainFilters.realEstateId &&
      GetAnual();
  }, [anualFilters]);

  // Actualiza las estadisticas del chart vs mensual de emprendim.
  useEffect(() => {
    mainFilters?.branchOffices?.length &&
      mainFilters.realEstateId &&
      GetProjMonth();
  }, [projMonthFilters]);

  // Actualiza las estadisticas del chart anual de emprendim.
  useEffect(() => {
    mainFilters?.branchOffices?.length &&
      mainFilters.realEstateId &&
      GetProjAnual();
  }, [projAnualFilters]);

  useEffect(() => {
    // mainFilters && console.log('mainFilters: ', mainFilters);
    if (mainFilters?.branchOffices?.length && mainFilters.realEstateId) {
      GetMonth();
      GetAnual();
      GetProjMonth();
      GetProjAnual();
    }
  }, [mainFilters]);

  // Solo para user type cucicba
  useEffect(() => {
    if (realEstateList && mainFilters?.realEstateId) {
      setMainFilters({ ...mainFilters, branchOffices: [] });
      dispatch(getRealEstateData(mainFilters.realEstateId));
    }
  }, [mainFilters?.realEstateId]);

  // Seteo el estado de real estate y oficinas a null
  useEffect(() => {
    dispatch(emptyAllRealEstateData());
  }, []);

  return (
    <>
      <Row className="g-3">
        <Col xs={12}>
          <PageHeader
            title="Estadísticas"
            description="Consulte el historial de estadísticas de su Inmobiliaria."
            className="bg-white"
          />
        </Col>

        <Col xs={12} md={8}>
          {/* Card con mensaje de gráfico no disponible */}
          <Card className="bg-white">
            <Card.Header className="d-flex justify-content-between border-bottom">
              <Card.Title className="fw-light d-flex align-items-center gap-2">
                <span className="fs-0">
                  <FaChartPie />
                </span>

                <span>Estadísticas anuales</span>
              </Card.Title>
            </Card.Header>

            <Card.Body>
              <CustomMessage
                message="Necesitamos más datos para poder brindarle estadísticas de calidad. En breve las podrá comenzar a visualizar."
                title="Estadísticas no disponibles."
                ReactIcon={FaChartPie}
                titleStyles={{ fontSize: 20 }}
              />
            </Card.Body>
          </Card>
        </Col>

        {/* Filtros inmobiliaria - sucursal */}
        {/* <Col xs={12}>
          {mainFilters && (
            <Card>
              <FalconCardHeader
                className="bg-white pb-0"
                title={
                  realEstateList
                    ? 'Filtrar por inmobiliaria y sucursal'
                    : 'Filtrar por sucursal'
                }
                titleTag="h6"
              />
              <Card.Body className="bg-white">
                <Row>
                  <Form.Group>
                    <Row>
                      <Col xs={realEstateList ? 6 : 12}>
                        <div className="mb-3">
                          {realEstateList && (
                            <SingleREFilter
                              setMainFilters={setMainFilters}
                              mainFilters={mainFilters}
                              options={[
                                {
                                  id: 0,
                                  name: 'Seleccionar inmobiliaria'
                                },
                                ...realEstateList
                              ]}
                            />
                          )}
                          {realEstate && <h5>{realEstate.name}</h5>}
                        </div>
                      </Col>

                      <Col xs={realEstateList ? 6 : 12}>
                        {(branchOffices || branchOfficesArray) && (
                          <BranchOfficeFilter
                            setFiltersAndSort={setMainFilters}
                            filtersAndSort={mainFilters}
                            branchOffices={
                              realEstateList
                                ? branchOfficesArray
                                : branchOffices
                            }
                            showTitle={false}
                          />
                        )}
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
              </Card.Body>
            </Card>
          )}
        </Col> */}

        {/* PROPS: Chart stats anuales */}
        {/* {!!mainFilters?.branchOffices?.length &&
          !!Object.keys(propsByMonth).length && (
            <Col xs={8}>
              <AnualChart
                anualFilters={anualFilters}
                setAnualFilters={setAnualFilters}
                stats={propsByMonth}
                title="Propiedades"
              />
            </Col>
          )} */}

        {/* PROPS: Chart mensual vs. */}
        {/* {!!mainFilters?.branchOffices?.length &&
          statsProps &&
          prevStatsProps && (
            <Col xs={4}>
              <MonthlyChart
                title={GenerateTitle('Propiedades', monthFilters)}
                monthFilters={monthFilters}
                setMonthFilters={setMonthFilters}
                stats={statsProps}
                prevStats={prevStatsProps}
              />
            </Col>
          )} */}

        {/* PROJECTS: Chart stats anuales */}
        {/* {!!mainFilters?.branchOffices?.length &&
          !!Object.keys(projectsByMonth).length && (
            <Col xs={8}>
              <AnualChart
                anualFilters={projAnualFilters}
                setAnualFilters={setProjAnualFilters}
                stats={projectsByMonth}
                title="Emprendimientos"
              />
            </Col>
          )} */}

        {/* PROJECTS: Chart mensual vs. */}
        {/* {!!mainFilters?.branchOffices?.length &&
          statsProjects &&
          prevStatsProjects && (
            <Col xs={4}>
              <MonthlyChart
                title={GenerateTitle('Emprendimientos', projMonthFilters)}
                monthFilters={projMonthFilters}
                setMonthFilters={setProjMonthFilters}
                stats={statsProjects}
                prevStats={prevStatsProjects}
              />
            </Col>
          )} */}
      </Row>
    </>
  );
};

export default MisEstadisticas;
